import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
// Dashboard Faz0 Clara: eski hâli — dashboard Türkçe mesajları artık lazy dashboard bileşenlerinde yükleniyor
// (libs/raporlar/src/lib/services/dashboard-localization.ts)
// import {
//   trMessages,
//   richTrMessages,
//   dashboardjsonTr
// } from '@dabnet-kamu/libs/ui/lib';
import {
  trMessages,
  richTrMessages
} from '@dabnet-kamu/libs/ui/lib';
import config from 'devextreme/core/config';
import { loadMessages, locale } from 'devextreme/localization';
import { DxLoadPanelModule } from 'devextreme-angular';
import { CommonModule } from '@angular/common';
// Dashboard Faz0 Clara: eski hâli — bu import devexpress-dashboard paketini ilk yüklemeye (vendor) çekiyordu
// import { ResourceManager } from 'devexpress-dashboard/common';
import { NotificationService } from 'libs/ui/src/lib/shared/services/notification.service';
import {LoadingService} from "@dabnet-kamu/libs/ui/shared/services/loading.service";
import {ErrorPopupComponent} from "@dabnet-kamu/libs/ui/shared/components/error-popup/error-popup.component";
import {
  GlobalAuthFetchService
} from "@dabnet-kamu/libs/auth/json-api-client-auth-init.service";
import {AuthService} from "@dabnet-kamu/libs/auth";
import {filter, take} from "rxjs";
import {IdleService} from "@dabnet-kamu/libs/auth/idle.service";
import {provideNgIdle, LocalStorage} from "@ng-idle/core";
import { Keepalive } from '@ng-idle/keepalive';


@Component({
  standalone: true,
  imports: [RouterModule, DxLoadPanelModule, CommonModule, ErrorPopupComponent],
  selector: 'dk-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    provideNgIdle(),
    Keepalive,
    LocalStorage
  ]
})
export class AppComponent {
  title = 'dabnet-kamu';
  loadingVisible = false;
  dynamicPosition = { of: '.dx-tabpanel-container' };

  constructor(private loadingService: LoadingService,
              private globalAuthFetchService: GlobalAuthFetchService,
              private authService : AuthService,
              private idleService: IdleService
  ) {
    this.authService.waitForUser().then(user => {
      this.globalAuthFetchService.init();
    });
    this.loadingService.loadingVisible$.subscribe((visible) => {
      this.loadingVisible = visible;
    });
    this.loadingService.position$.subscribe((pos) => {
      this.dynamicPosition = pos;
    });


    // Specifying a currency globally
    // Test bir sorgu
    config({ defaultCurrency: 'TRY',forceIsoDateParsing: true });

    locale('tr');
    loadMessages(trMessages);
    loadMessages({ tr: richTrMessages });
    // Dashboard Faz0 Clara: eski hâli — artık dk-dynamic-dashboard / dk-dashboard-page constructor'ında
    // dashboardTurkceYerellestirmeUygula() ile (bir kez) yükleniyor
    // ResourceManager.setLocalizationMessages(dashboardjsonTr);
  }

  updatePosition(newSelector: string) { this.dynamicPosition = { of: newSelector }; }


}
